import { Component, OnInit, ViewChild } from '@angular/core';
import {DatePipe, Location} from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { SofortTransactionImportsService } from '../../services/sofort-transaction-imports.service';
import { MultiCrudDataSource } from '../../../table-datasouces/multi-crud.datasource';
import { MatTableGeneratorComponent } from '../../../shared/mat-table-generator/mat-table-generator.component';
import { FileImportDialogComponent } from '../../../shared/file-import-dialog/file-import-dialog.component';
import { SofortTransactionImport } from '../../../dto/sofort-transaction-import';
import { DateFormats } from '../../../providers/app-date-adapter';
import { RoleService } from '../../../services/role.service';
import {MatDialog} from '@angular/material/dialog';

@Component( {
  selector: 'app-sofort-transaction-imports',
  templateUrl: './sofort-transaction-imports.component.html',
  styleUrls: ['./sofort-transaction-imports.component.css']
} )

export class SofortTransactionImportsComponent implements OnInit {

  dataSource = new MultiCrudDataSource( this.importService );

  @ViewChild(MatTableGeneratorComponent, { static: true }) table: MatTableGeneratorComponent;

  constructor(
    private importService: SofortTransactionImportsService,
    private datePipe: DatePipe,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private router: Router,
    private roleService: RoleService,
    private location: Location,
  ) { }

  importsCols = [
    { columnDef: 'id', header: 'id', cell: ( row: SofortTransactionImport ) => `${ row.id }` },
    { columnDef: 'date', header: 'Date', cell: ( row: SofortTransactionImport ) => `${ this.datePipe.transform( row.date, DateFormats.DisplayDateTime  )}` },
    { columnDef: 'userId', header: 'User', cell: ( row: SofortTransactionImport ) => `${ row.username }` },
    { columnDef: 'ipAddress', header: 'Ip address', cell: ( row: SofortTransactionImport ) => `${ row.ipAddress }` },
    { columnDef: 'totalRowCount', header: 'Total rows', cell: ( row: SofortTransactionImport ) => `${ row.totalRowCount }` },
    { columnDef: 'invalidRowCount', header: 'Invalid rows', cell: ( row: SofortTransactionImport ) => `${ row.invalidRowCount }` },
  ];

  ngOnInit() { }

  /**
   * Upload file to server, process result,
   * after upload show modal dialog, whare user can go over
   * imported sofort transactions
   *
   * @param file file for upload
   */
  onUpload( file ) {
    this.importService.upload( file )
      .subscribe( result => {
        this.dataSource.data.push( result );
        this.table.refreshTable();

        this.dialog.open( FileImportDialogComponent, {
          data: {
            import: result,
            link: this.router.url + '/' + result.id.toString()
          },
          maxWidth: 400,
        } );
      } );
  }

  gotoImport( id: number ) {
    this.router.navigate( [ id ], { relativeTo: this.route } );
  }

  getRowClass = ( item: SofortTransactionImport ): string => item.invalidRowCount > 0 ? 'warning-row' : '';

  getViewLink = ( item: SofortTransactionImport ): string => item.id.toString();
  deleteEnabled() {
    return this.roleService.hasRoles( 'admin' );
  }

  multiselectEnabled() {
    return this.roleService.hasRoles( ['admin'] );
  }

  returnBack() {
    this.location.back();
  }
}
